import { MAX_DIMENSION, JPEG_QUALITY } from './imageConfig';
import { IMAGE_PROCESSING_ERRORS } from './validateImageSize';

const preScaleWithBitmap = async (source, outputName) => {
  const globalObj =
    typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : null;

  let bitmap;
  try {
    bitmap = await globalObj.createImageBitmap(source);
  } catch (error) {
    throw new Error(IMAGE_PROCESSING_ERRORS.CORRUPT_ERROR);
  }

  const scale = Math.min(
    1,
    MAX_DIMENSION / Math.max(bitmap.width, bitmap.height)
  );
  const width = Math.round(bitmap.width * scale);
  const height = Math.round(bitmap.height * scale);

  let canvas;
  let result;

  try {
    canvas = new globalObj.OffscreenCanvas(width, height);
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      throw new Error(IMAGE_PROCESSING_ERRORS.MEMORY_ERROR);
    }

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(bitmap, 0, 0, width, height);

    const blob = await canvas.convertToBlob({
      type: 'image/jpeg',
      quality: JPEG_QUALITY,
    });

    if (!blob) {
      throw new Error(IMAGE_PROCESSING_ERRORS.MEMORY_ERROR);
    }

    result = new File([blob], outputName, { type: 'image/jpeg' });
  } finally {
    bitmap.close();
    if (canvas) canvas.width = 0;
  }

  return result;
};

export default preScaleWithBitmap;
